module.exports = __webpack_public_path__ + "static/DXies-News_logo-7acac39739c5852809ee3ba402078917.png";